export function useLivesSetting() {
  // 保存直播间设置参数到本地，带上 id
  function saveLiveRoomSettings(id: string, settings: object) {
    if (!id || typeof id !== 'string') {
      console.error('无效的直播间 ID');
      return;
    }
    if (!settings || typeof settings !== 'object') {
      console.error('无效的设置对象');
      return;
    }
    try {
      const key = `liveRoomSettings_${id}`;
      localStorage.setItem(key, JSON.stringify(settings));
      console.log(`直播间设置已保存: ${key}`);
    } catch (error) {
      console.error(`保存直播间设置失败 (ID: ${id}):`, error);
    }
  }

  // 清空指定直播间设置
  function clearLiveRoomSettings(id: string) {
    if (!id || typeof id !== 'string') {
      console.error('无效的直播间 ID');
      return;
    }
    try {
      const key = `liveRoomSettings_${id}`;
      localStorage.removeItem(key);
      console.log(`直播间设置已清空: ${key}`);
    } catch (error) {
      console.error(`清空直播间设置失败 (ID: ${id}):`, error);
    }
  }

  // 提取并更新直播间设置参数，带上 id
  function loadLiveRoomSettings(id: string) {
    if (!id || typeof id !== 'string') {
      console.error('无效的直播间 ID');
      return null;
    }
    try {
      const key = `liveRoomSettings_${id}`;
      const settings = localStorage.getItem(key);
      if (settings) {
        const parsedSettings = JSON.parse(settings);
        console.log(`直播间设置已加载: ${key}`, parsedSettings);
        return parsedSettings;
      } else {
        console.warn(`未找到直播间设置 (ID: ${id})`);
      }
    } catch (error) {
      console.error(`加载直播间设置失败 (ID: ${id}):`, error);
    }
    return null;
  }

  return {
    saveLiveRoomSettings,
    loadLiveRoomSettings,
    clearLiveRoomSettings,
  };
}
